
/* styles */
require("!!vue-style-loader!css-loader!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-11f75e96!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SpouseForm.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./SpouseForm.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-11f75e96!../../node_modules/vue-loader/lib/selector?type=template&index=0!./SpouseForm.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/SpouseForm.vue
// module id = 303
// module chunks = 0